import React, { FC, useEffect, useRef } from 'react'
import { ImageElement, VideoElement } from '../../templateEditor.types'
import elementStyles from './templateEditorElementViews.jcss'

type Props = { element: ImageElement | VideoElement; scale: number }

export const TemplateEditorMediaView: FC<Props> = ({ element }) => {
    const videoRef = useRef<HTMLVideoElement>(null)
    const previewSrc = element.thumbnail || element.src

    useEffect(() => {
        const video = videoRef.current
        if (!video || element.type !== 'video') {
            return
        }

        video.muted = true
        const playPromise = video.play()
        if (playPromise) {
            playPromise.catch(() => {})
        }
    }, [element.src, element.type])

    if (element.type === 'video') {
        return (
            <div className={elementStyles.media}>
                {element.src ? (
                    <video
                        ref={videoRef}
                        className={elementStyles.mediaVideo}
                        src={element.src}
                        poster={element.thumbnail}
                        muted
                        loop
                        autoPlay
                        playsInline
                        preload="auto"
                        style={{ objectFit: element.objectFit }}
                    />
                ) : (
                    <div className={elementStyles.mediaPlaceholder} />
                )}
            </div>
        )
    }

    return (
        <div className={elementStyles.media}>
            {previewSrc ? (
                <img
                    className={elementStyles.mediaImage}
                    src={previewSrc}
                    alt=""
                    draggable={false}
                    style={{ objectFit: element.objectFit || 'contain' }}
                />
            ) : (
                <div className={elementStyles.mediaPlaceholder} />
            )}
        </div>
    )
}
